export default __webpack_public_path__ + "static/media/quick-turnaround.81158829.svg";